import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import App from './App';
import { applyThemeToDocument, THEME_LIGHT, THEME_DARK } from './contexts/ThemeContext';

// Aplicar tema salvo antes do primeiro paint (evita flash)
(() => {
  let theme = THEME_LIGHT;
  try {
    const stored = localStorage.getItem('extk_onda_theme');
    if (stored === THEME_DARK || stored === THEME_LIGHT) theme = stored;
    else if (stored === 'extk') theme = THEME_DARK;
  } catch {
    /* ignore */
  }
  applyThemeToDocument(theme);
})();

const meta = document.querySelector('meta[name="theme-color"]') || (() => {
  const m = document.createElement('meta');
  m.setAttribute('name', 'theme-color');
  document.head.appendChild(m);
  return m;
})();
if (!meta.getAttribute('content')) {
  meta.setAttribute('content', '#0D9488');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
